/**
 * 存储和时间抽象，使 GameCore 保持与浏览器无关。
 *
 * CLAUDE.md §5：Game Core 不得依赖浏览器 API。这些接口使引擎
 * 可以在 Node.js 中测试或通过注入的适配器驱动。
 */

export interface StorageAdapter {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
  key(index: number): string | null;
  get length(): number;
}

export interface TimeSource {
  now(): number;
}

/** 由浏览器 localStorage 支持的基础适配器。用于生产环境。 */
export const BrowserStorageAdapter: StorageAdapter = {
  getItem(key: string): string | null {
    const ls = typeof globalThis !== "undefined" ? (globalThis as any).localStorage : null;
    return ls ? ls.getItem(key) : null;
  },
  setItem(key: string, value: string): void {
    const ls = typeof globalThis !== "undefined" ? (globalThis as any).localStorage : null;
    if (ls) ls.setItem(key, value);
  },
  removeItem(key: string): void {
    const ls = typeof globalThis !== "undefined" ? (globalThis as any).localStorage : null;
    if (ls) ls.removeItem(key);
  },
  key(index: number): string | null {
    const ls = typeof globalThis !== "undefined" ? (globalThis as any).localStorage : null;
    return ls ? ls.key(index) : null;
  },
  get length(): number {
    const ls = typeof globalThis !== "undefined" ? (globalThis as any).localStorage : null;
    return ls ? ls.length : 0;
  },
};

/** 由 Date.now() 支持的基础时间源。用于生产环境。 */
export const SystemTimeSource: TimeSource = {
  now: () => Date.now(),
};
